import { render } from "./Thongkebenhnhan.vue?vue&type=template&id=1aa45a71&scoped=true&ts=true"
import script from "./Thongkebenhnhan.vue?vue&type=script&lang=ts"
export * from "./Thongkebenhnhan.vue?vue&type=script&lang=ts"

import "./Thongkebenhnhan.vue?vue&type=style&index=0&id=1aa45a71&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/Dashboard_HV/Dashboard_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa45a71"]])

export default __exports__